export const SSO_POPUP_TOKEN_KEY = 'ssoPopupToken';

export const handOffSsoPopupToken = (token: string) => {
  localStorage.setItem(SSO_POPUP_TOKEN_KEY, token);
  localStorage.removeItem(SSO_POPUP_TOKEN_KEY);
};
